// import React, { useState } from 'react';

// import './product.css';
// import ChatWidget from './CahtWidget';

// export default function ProductPage() {
//   const [selectedColor, setSelectedColor] = useState('قرمز');
//   const [selectedSize, setSelectedSize] = useState('38');

//   return (
//     <div dir="rtl" className="product-container">
//       <div className="product-box">
//         <img
//           className="product-image"
//           src="https://sainacharm.com/wp-content/uploads/2022/08/c101.jpg"
//           alt="کفش مدل C101"
//         />

//         <h2 className="product-title">کفش پاشنه‌دار مدل C101</h2>

//         <p className="product-price">۱,۶۹۹,۰۰۰ تومان</p>

//         <div className="section">
//           <label>رنگ:</label>
//           <select
//             value={selectedColor}
//             onChange={(e) => setSelectedColor(e.target.value)}>
//             <option>قرمز</option>
//             <option>طوسی</option>
//             <option>مشکی</option>
//           </select>
//         </div>

//         <div className="section">
//           <label>سایز:</label>
//           <select
//             value={selectedSize}
//             onChange={(e) => setSelectedSize(e.target.value)}>
//             <option>37</option>
//             <option>38</option>
//             <option>39</option>
//           </select>
//         </div>

//         <button className="buy-btn">افزودن به سبد</button>

//         <p className="desc">
//           این یک توضیح نمونه برای صفحه محصول دمو است. هدف فقط ساخت نمایی مشابه
//           صفحه واقعی فروشگاه برای اسکرین‌ریکورد است.
//         </p>
//       </div>

//       <ChatWidget />
//     </div>
//   );
// }

import React, { useState } from 'react';

import './chat.css';
import ChatWidget from './CahtWidget';

export default function ProductPage() {
  const [open, setOpen] = useState(false);

  return (
    <div dir="rtl" className="product-page">
      {/* صفحه محصول */}
      <div className="product-container">
        <img
          src="https://sainacharm.com/wp-content/uploads/2022/08/c101.jpg"
          className="product-img"
          alt="demo"
        />
        <h1 className="product-title">کفش پاشنه‌دار مدل C101</h1>
        <p className="product-desc">
          کفش چرم زنانه با رویه و استر داخلی چرم طبیعی، مناسب برای استفاده
          روزمره و مهمانی.
        </p>

        <div className="price">۱,۶۹۹,۰۰۰ تومان</div>
      </div>

      {/* آیکون ویجت */}
      {!open && (
        <div className="chat-launcher" onClick={() => setOpen(true)}>
          💬
        </div>
      )}

      {/* ویجت چت */}
      {open && (
        <div className="chat-popup">
          <div className="chat-close" onClick={() => setOpen(false)}>
            ✖
          </div>
          <ChatWidget />
        </div>
      )}
    </div>
  );
}
